var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoyride(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 287.005,
    height: 244.244,
    viewBox: "0 0 287.005 244.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2023",
    "data-name": "Grupo 2023",
    transform: "translate(-1501.995 -249.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_joyride_re_968t",
    transform: "translate(1501.995 250.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_81",
    "data-name": "Elipse 81",
    transform: "translate(78.02 78.832)",
    fill: "#ffc42d",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.054,
    cy: 71.054,
    r: 71.054,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.054,
    cy: 71.054,
    r: 70.554,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14634",
    "data-name": "Trazado 14634",
    d: "M890.181,729.466l-4.827,4.444,3.836-6.436a49.706,49.706,0,0,0-7.965-10.217s-10.254,9.824-10.254,17.547,4.591,10.419,10.254,10.419,10.254-2.7,10.254-10.419A13.546,13.546,0,0,0,890.181,729.466Z",
    transform: "translate(-632.858 -502.621)",
    fill: "#ffebbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14635",
    "data-name": "Trazado 14635",
    d: "M903.12,733.352v.381c-.023,4.425-.769,7.877-2.233,10.308-.021.036-.043.07-.064.105l-.164-.1-.156-.1c1.624-2.625,2.2-6.336,2.22-10.2,0-.124,0-.251,0-.377-.006-1.634-.106-3.287-.266-4.892-.011-.124-.024-.251-.038-.377-.222-2.118-.543-4.142-.871-5.9-.023-.124-.047-.249-.072-.371-.567-2.974-1.146-5.128-1.278-5.6-.015-.058-.025-.09-.026-.1l.179-.051,0,0,.181-.051c0,.008.034.115.087.315.2.746.726,2.772,1.24,5.444.023.121.047.245.07.369.268,1.427.529,3.021.737,4.694q.079.63.141,1.244c.015.126.028.253.04.377Q903.11,731.076,903.12,733.352Z",
    transform: "translate(-651.865 -501.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14636",
    "data-name": "Trazado 14636",
    d: "M893.717,730.873c-.126.017-.254.034-.384.047a10.407,10.407,0,0,1-1.063.055,10.113,10.113,0,0,1-4.372-.987l-.239.3a10.488,10.488,0,0,0,4.611,1.063,10.769,10.769,0,0,0,1.134-.06c.128-.013.256-.03.383-.049a10.4,10.4,0,0,0,3.006-.91l-.237-.305A10.078,10.078,0,0,1,893.717,730.873Z",
    transform: "translate(-643.719 -510.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14637",
    "data-name": "Trazado 14637",
    d: "M890.8,742.488q-.2.011-.39.011c-.04,0-.081,0-.121,0a10.166,10.166,0,0,1-8.345-4.359c-.075.111-.151.222-.224.335a10.544,10.544,0,0,0,8.569,4.4c.053,0,.106,0,.158,0,.132,0,.262-.006.392-.011a10.488,10.488,0,0,0,5.587-1.96c-.06-.111-.121-.222-.183-.333A10.1,10.1,0,0,1,890.8,742.488Z",
    transform: "translate(-639.854 -516.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14638",
    "data-name": "Trazado 14638",
    d: "M888.4,752.033c-.132.011-.264.019-.4.024s-.283.009-.424.009a10.194,10.194,0,0,1-9.773-7.334c-.085.153-.17.3-.251.456a10.567,10.567,0,0,0,10.023,7.255c.141,0,.283,0,.422-.009s.266-.011.4-.021a10.537,10.537,0,0,0,6.954-3.394c-.04-.139-.085-.277-.13-.416A10.161,10.161,0,0,1,888.4,752.033Z",
    transform: "translate(-637.143 -520.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14639",
    "data-name": "Trazado 14639",
    d: "M801.4,251.148l.2-3.853,1.034,4.283a29.231,29.231,0,0,0,7.549,1.021s.272-8.347-2.9-11.593-6.214-2.493-8.6-.165-3.2,5.35-.028,8.6A7.966,7.966,0,0,0,801.4,251.148Z",
    transform: "translate(-584.441 -191.238)",
    fill: "#ffebbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14640",
    "data-name": "Trazado 14640",
    d: "M805.711,251.019l-.156-.16a11.953,11.953,0,0,1-3.3-5.252c-.006-.024-.01-.047-.016-.071l.11-.025.106-.023a11.821,11.821,0,0,0,3.258,5.2c.05.053.1.107.154.159.674.685,1.4,1.338,2.123,1.948l.171.143c.964.8,1.931,1.518,2.792,2.123l.183.127c1.461,1.017,2.59,1.685,2.841,1.831l.051.03-.054.1v0l-.055.1s-.061-.034-.166-.1c-.392-.231-1.445-.867-2.76-1.779l-.181-.127c-.7-.49-1.465-1.052-2.24-1.671q-.292-.232-.571-.465c-.058-.047-.116-.095-.172-.142Q806.65,251.971,805.711,251.019Z",
    transform: "translate(-588.124 -195.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14641",
    "data-name": "Trazado 14641",
    d: "M825.317,269.588c.046-.059.093-.119.142-.178a6.1,6.1,0,0,1,.424-.46,5.947,5.947,0,0,1,2.244-1.382c-.008-.075-.016-.149-.023-.225a6.167,6.167,0,0,0-2.376,1.449,6.341,6.341,0,0,0-.452.492c-.048.058-.1.118-.141.178a6.115,6.115,0,0,0-.89,1.618l.225.031A5.929,5.929,0,0,1,825.317,269.588Z",
    transform: "translate(-602.447 -209.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14642",
    "data-name": "Trazado 14642",
    d: "M815.547,263.3q.077-.085.159-.165c.016-.017.033-.034.05-.05a5.978,5.978,0,0,1,5.3-1.6c-.014-.078-.028-.155-.044-.233a6.2,6.2,0,0,0-5.412,1.673c-.022.022-.044.043-.066.066-.055.055-.108.11-.16.166a6.168,6.168,0,0,0-1.543,3.121l.214.065A5.937,5.937,0,0,1,815.547,263.3Z",
    transform: "translate(-595.669 -205.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14643",
    "data-name": "Trazado 14643",
    d: "M809.036,257.086c.051-.059.1-.116.156-.173s.115-.12.174-.178a5.994,5.994,0,0,1,7.124-.934c-.027-.1-.053-.2-.082-.295a6.214,6.214,0,0,0-7.2,1.071c-.059.058-.118.117-.174.177s-.107.114-.159.172a6.2,6.2,0,0,0-1.528,4.286c.074.042.15.082.226.122A5.975,5.975,0,0,1,809.036,257.086Z",
    transform: "translate(-591.449 -201.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14644",
    "data-name": "Trazado 14644",
    d: "M382.164,333.148l.2-3.853,1.033,4.283a29.232,29.232,0,0,0,7.549,1.021s.272-8.347-2.9-11.593-6.214-2.493-8.6-.165-3.2,5.35-.028,8.6A7.967,7.967,0,0,0,382.164,333.148Z",
    transform: "translate(-311.581 -244.607)",
    fill: "#ffebbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14645",
    "data-name": "Trazado 14645",
    d: "M386.472,333.019l-.156-.16a11.954,11.954,0,0,1-3.3-5.252c-.006-.024-.01-.047-.016-.071l.11-.025.106-.023a11.822,11.822,0,0,0,3.258,5.2c.05.053.1.107.154.159.674.685,1.4,1.338,2.123,1.948l.171.143c.964.8,1.931,1.518,2.792,2.123l.183.127c1.461,1.017,2.59,1.685,2.841,1.831l.051.03-.054.1v0l-.055.1s-.062-.034-.166-.1c-.392-.231-1.445-.867-2.76-1.779l-.181-.127c-.7-.49-1.465-1.052-2.24-1.671q-.292-.232-.571-.465c-.058-.047-.116-.095-.172-.142Q387.411,333.971,386.472,333.019Z",
    transform: "translate(-315.264 -248.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14646",
    "data-name": "Trazado 14646",
    d: "M406.078,351.588c.046-.059.093-.119.142-.178a6.116,6.116,0,0,1,.424-.46,5.946,5.946,0,0,1,2.244-1.382c-.008-.075-.016-.149-.023-.225a6.167,6.167,0,0,0-2.376,1.449,6.329,6.329,0,0,0-.452.492c-.048.058-.1.118-.141.178a6.114,6.114,0,0,0-.889,1.618l.225.031A5.927,5.927,0,0,1,406.078,351.588Z",
    transform: "translate(-329.587 -263.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14647",
    "data-name": "Trazado 14647",
    d: "M396.308,345.3q.077-.085.159-.165c.016-.017.033-.034.05-.05a5.978,5.978,0,0,1,5.3-1.6c-.014-.078-.028-.155-.044-.233a6.2,6.2,0,0,0-5.412,1.673c-.022.022-.044.043-.066.066-.055.055-.108.11-.16.166a6.168,6.168,0,0,0-1.543,3.121l.214.065A5.937,5.937,0,0,1,396.308,345.3Z",
    transform: "translate(-322.809 -259.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14648",
    "data-name": "Trazado 14648",
    d: "M389.8,339.086c.051-.059.1-.116.156-.173s.115-.12.174-.178a5.994,5.994,0,0,1,7.124-.934c-.027-.1-.053-.2-.082-.295a6.214,6.214,0,0,0-7.2,1.071c-.059.058-.118.117-.174.178s-.107.114-.159.172a6.2,6.2,0,0,0-1.528,4.286c.074.042.15.082.226.122a5.975,5.975,0,0,1,1.459-4.247Z",
    transform: "translate(-318.589 -255.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14649",
    "data-name": "Trazado 14649",
    d: "M452.164,193.148l.2-3.853,1.033,4.283a29.231,29.231,0,0,0,7.549,1.021s.272-8.347-2.9-11.593-6.214-2.493-8.6-.165-3.2,5.35-.028,8.6A7.966,7.966,0,0,0,452.164,193.148Z",
    transform: "translate(-357.141 -153.489)",
    fill: "#ffebbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14650",
    "data-name": "Trazado 14650",
    d: "M456.472,193.019l-.156-.16a11.953,11.953,0,0,1-3.3-5.252c-.006-.024-.01-.047-.016-.071l.11-.025.106-.023a11.822,11.822,0,0,0,3.258,5.2c.05.053.1.107.154.159.674.685,1.4,1.338,2.123,1.948l.171.143c.964.8,1.931,1.518,2.792,2.123l.183.127c1.461,1.017,2.59,1.685,2.841,1.831l.051.03-.054.095v0l-.055.1s-.062-.034-.166-.1c-.392-.231-1.445-.867-2.76-1.779l-.181-.127c-.7-.49-1.465-1.052-2.24-1.671q-.292-.232-.571-.465c-.058-.047-.116-.095-.172-.142Q457.411,193.971,456.472,193.019Z",
    transform: "translate(-360.823 -157.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14651",
    "data-name": "Trazado 14651",
    d: "M476.078,211.588c.046-.059.093-.119.142-.178a6.1,6.1,0,0,1,.424-.46,5.946,5.946,0,0,1,2.244-1.382c-.008-.075-.016-.149-.023-.225a6.167,6.167,0,0,0-2.376,1.449,6.339,6.339,0,0,0-.452.492c-.048.058-.1.118-.141.178a6.115,6.115,0,0,0-.889,1.618l.225.031A5.927,5.927,0,0,1,476.078,211.588Z",
    transform: "translate(-375.146 -172.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14652",
    "data-name": "Trazado 14652",
    d: "M466.308,205.3q.077-.085.159-.165c.016-.017.033-.034.05-.05a5.978,5.978,0,0,1,5.3-1.6c-.014-.078-.028-.155-.044-.233a6.2,6.2,0,0,0-5.412,1.673c-.022.022-.044.043-.066.066-.055.055-.108.11-.16.166a6.167,6.167,0,0,0-1.543,3.121l.214.065A5.937,5.937,0,0,1,466.308,205.3Z",
    transform: "translate(-368.369 -168.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14653",
    "data-name": "Trazado 14653",
    d: "M459.8,199.086c.051-.059.1-.116.156-.173s.115-.12.174-.178a6,6,0,0,1,7.124-.934c-.027-.1-.053-.2-.082-.295a6.214,6.214,0,0,0-7.2,1.071c-.059.058-.118.117-.174.178s-.107.114-.159.172a6.2,6.2,0,0,0-1.528,4.286c.074.042.15.082.226.122A5.975,5.975,0,0,1,459.8,199.086Z",
    transform: "translate(-364.148 -163.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14654",
    "data-name": "Trazado 14654",
    d: "M239.641,678.748l-8.362,7.7,6.645-11.15c-5.235-9.494-13.8-17.7-13.8-17.7s-17.764,17.019-17.764,30.4,7.953,18.05,17.764,18.05,17.764-4.671,17.764-18.05A23.468,23.468,0,0,0,239.641,678.748Z",
    transform: "translate(-200.3 -463.792)",
    fill: "#ffebbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14655",
    "data-name": "Trazado 14655",
    d: "M262.055,685.48v.659c-.039,7.665-1.332,13.646-3.868,17.857-.036.062-.075.121-.111.183l-.284-.173-.271-.17c2.814-4.547,3.81-10.975,3.846-17.661,0-.216.007-.434,0-.653-.01-2.83-.183-5.693-.46-8.475-.02-.215-.042-.434-.065-.653-.385-3.669-.94-7.176-1.508-10.221-.039-.215-.082-.431-.124-.643-.983-5.151-1.985-8.883-2.213-9.709-.026-.1-.042-.157-.046-.17l.31-.088,0,0,.313-.088c0,.013.059.2.15.545.349,1.293,1.257,4.8,2.148,9.431.039.209.082.424.121.64.464,2.471.917,5.233,1.276,8.132q.137,1.092.245,2.155c.026.219.049.438.069.653Q262.039,681.538,262.055,685.48Z",
    transform: "translate(-233.227 -462.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14656",
    "data-name": "Trazado 14656",
    d: "M245.766,681.185c-.219.029-.441.059-.666.082a17.994,17.994,0,0,1-1.841.095,17.518,17.518,0,0,1-7.574-1.711l-.415.522a18.167,18.167,0,0,0,7.988,1.841,18.608,18.608,0,0,0,1.965-.1c.222-.023.444-.052.663-.085a18.014,18.014,0,0,0,5.207-1.577l-.411-.529a17.457,17.457,0,0,1-4.916,1.466Z",
    transform: "translate(-219.115 -478.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14657",
    "data-name": "Trazado 14657",
    d: "M240.714,701.307q-.338.02-.676.02c-.069,0-.14,0-.209,0a17.612,17.612,0,0,1-14.456-7.551c-.13.193-.261.385-.388.581a18.266,18.266,0,0,0,14.844,7.623c.091,0,.183,0,.274,0,.229,0,.454-.01.679-.02a18.17,18.17,0,0,0,9.679-3.4c-.1-.193-.209-.385-.317-.578a17.49,17.49,0,0,1-9.431,3.32Z",
    transform: "translate(-212.421 -487.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14658",
    "data-name": "Trazado 14658",
    d: "M236.552,717.842c-.228.02-.457.033-.686.042-.245.01-.49.016-.735.016A17.659,17.659,0,0,1,218.2,705.2c-.147.264-.294.526-.434.79a18.306,18.306,0,0,0,17.364,12.569c.245,0,.49,0,.731-.016s.46-.02.689-.036a18.252,18.252,0,0,0,12.046-5.879c-.069-.242-.147-.48-.225-.721a17.6,17.6,0,0,1-11.821,5.942Z",
    transform: "translate(-207.723 -494.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14659",
    "data-name": "Trazado 14659",
    d: "M481.187,468.625a71.577,71.577,0,1,1,71.577-71.577A71.658,71.658,0,0,1,481.187,468.625Zm0-142.455a70.878,70.878,0,1,0,70.878,70.878A70.959,70.959,0,0,0,481.187,326.171Z",
    transform: "translate(-332.583 -247.63)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14660",
    "data-name": "Trazado 14660",
    d: "M475.36,532.728A63.007,63.007,0,0,1,434.1,460.69,63,63,0,1,0,552.208,501.32,63.007,63.007,0,0,1,475.36,532.728Z",
    transform: "translate(-344.205 -335.636)",
    fill: "#e9bc4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14661",
    "data-name": "Trazado 14661",
    d: "M541.983,482.257c-3.623,0-6.571-3.836-6.571-8.551s2.948-8.551,6.571-8.551,6.571,3.836,6.571,8.551S545.607,482.257,541.983,482.257Z",
    transform: "translate(-414.461 -338.542)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14662",
    "data-name": "Trazado 14662",
    d: "M655.983,482.257c-3.623,0-6.571-3.836-6.571-8.551s2.948-8.551,6.571-8.551,6.571,3.836,6.571,8.551S659.607,482.257,655.983,482.257Z",
    transform: "translate(-488.657 -338.542)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14664",
    "data-name": "Trazado 14664",
    d: "M223.209,323.95,221,320.283l13.1-10.26,3.258,5.413Z",
    transform: "translate(-143.838 -201.777)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14665",
    "data-name": "Trazado 14665",
    d: "M394.487,437.6l-7.118-11.825.15-.09a5.373,5.373,0,0,1,7.373,1.832h0l4.347,7.223Z",
    transform: "translate(-318.107 -312.352)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14666",
    "data-name": "Trazado 14666",
    d: "M596.081,309.95l2.207-3.668-13.1-10.26-3.258,5.413Z",
    transform: "translate(-378.75 -192.665)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14667",
    "data-name": "Trazado 14667",
    d: "M806.407,420.74l4.347-7.223h0a5.373,5.373,0,0,1,7.373-1.832l.15.09L811.16,423.6Z",
    transform: "translate(-590.837 -303.24)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14668",
    "data-name": "Trazado 14668",
    d: "M288.713,195.734l-.834,3.33-22.5,18.009L241.173,239.7l2.6,6.038,57.707-38.623,65.058,33.723,2.907-6.657-29.689-19.9L315.2,197.348Z",
    transform: "translate(-156.966 -127.393)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14669",
    "data-name": "Trazado 14669",
    d: "M569.9,196.236l-9.723,3.19,1.314,35.419S578.4,245,588.814,233.473V198.047l-5.806-1.811Z",
    transform: "translate(-430.58 -163.517)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14670",
    "data-name": "Trazado 14670",
    d: "M629.869,203.857l2.158-2.435s6,2.192,5.5,8.769-4.027,27.5-4.027,27.5l-.663,13.646h-6.264l2.5-35.29Z",
    transform: "translate(-473.792 -166.893)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14671",
    "data-name": "Trazado 14671",
    d: "M553.682,206.857l-2.158-2.435s-6,2.192-5.5,8.769,4.027,27.5,4.027,27.5l.663,13.646h6.264l-2.5-35.29Z",
    transform: "translate(-421.349 -168.845)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_75",
    "data-name": "Elipse 75",
    cx: 3.841,
    cy: 3.841,
    r: 3.841,
    transform: "translate(128.702 83.428)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_76",
    "data-name": "Elipse 76",
    cx: 3.841,
    cy: 3.841,
    r: 3.841,
    transform: "translate(152.095 83.428)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14672",
    "data-name": "Trazado 14672",
    d: "M576.256,140.342a11.664,11.664,0,0,0,6.666,2.06,7.147,7.147,0,0,1-2.833,1.165,23.519,23.519,0,0,0,9.607.054,6.216,6.216,0,0,0,2.011-.691,2.545,2.545,0,0,0,1.241-1.66c.211-1.2-.727-2.3-1.7-3.035a12.558,12.558,0,0,0-10.553-2.109,5.779,5.779,0,0,0-3.125,1.766,2.847,2.847,0,0,0-.263,3.381Z",
    transform: "translate(-441.044 -124.15)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14673",
    "data-name": "Trazado 14673",
    d: "M475.656,796.17H189.349a.349.349,0,1,1,0-.7H475.656a.349.349,0,1,1,0,.7Z",
    transform: "translate(-189 -553.528)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14674",
    "data-name": "Trazado 14674",
    d: "M583.61,610.472a9.776,9.776,0,1,0,19.553,0Z",
    transform: "translate(-445.83 -433.121)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_79",
    "data-name": "Elipse 79",
    cx: 8.38,
    cy: 8.38,
    r: 8.38,
    transform: "translate(175.182 148.371)",
    fill: "#e9bc4c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_80",
    "data-name": "Elipse 80",
    cx: 8.38,
    cy: 8.38,
    r: 8.38,
    transform: "translate(102.907 148.371)",
    fill: "#e9bc4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14600",
    "data-name": "Trazado 14600",
    d: "M53.485,21.9c0,8.046-12.648.687-26.209.687S0,29.642,0,21.6c0-4.588,4.371-10.968,10.643-15.6h0C15.368,2.5,21.17,0,27,0c5.994,0,11.865,2.708,16.549,6.425C49.459,11.112,53.485,17.41,53.485,21.9Z",
    transform: "translate(173.897 188.857) rotate(180)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14601",
    "data-name": "Trazado 14601",
    d: "M32.9,6.425C25.7,5.34,12.658,4.016,0,5.994,4.725,2.5,10.527,0,16.356,0,22.348,0,28.219,2.708,32.9,6.425Z",
    transform: "translate(163.254 188.859) rotate(180)",
    fill: "#f6f8fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    transform: "translate(-847.055 -4843.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_907",
    "data-name": "Trazado 907",
    d: "M2304.583,76.3s-5.406-6.687-3.138-9.341,5.776,0,5.776,0a3.1,3.1,0,0,1,3.691-2.815c3.5.324,5.605,4.052,5.605,4.052s3.079-3.08,5.186,0,.648,8.1.648,8.1,2.431-.36,1.783,2.494-4.472,5.8-4.472,5.8Z",
    transform: "translate(182.01 5034.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_908",
    "data-name": "Trazado 908",
    d: "M2352.813,238.625l.1,7.542s-1.33,2.186-5.736,2.6c-3.283.312-4.448-.416-4.448-.416l.407-3.826.4-3.731,7.943-1.86Z",
    transform: "translate(145.614 4882.221)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_909",
    "data-name": "Trazado 909",
    d: "M2354.2,241.035a2.472,2.472,0,0,1-.209.731c-1.637,3.79-6.238,4.665-8.134,4.86l.4-3.731Z",
    transform: "translate(142.895 4880.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_910",
    "data-name": "Trazado 910",
    d: "M2316.837,104.3s-3.83,9.509-2.2,14.742,6.412,4.263,9.258,3.16a9.518,9.518,0,0,0,4.129-2.906,4.055,4.055,0,0,0,4.437-1.717c1.724-2.55.535-5.387-1.018-6a4.219,4.219,0,0,0-3.345.547l1.35-2.77s-6.416-13.694-12.613-5.056",
    transform: "translate(170.402 5001.549)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_911",
    "data-name": "Trazado 911",
    d: "M2420.985,196.466a.348.348,0,0,1-.207-.629l2.841-2.1a.349.349,0,1,1,.414.561l-2.841,2.1a.346.346,0,0,1-.208.069",
    transform: "translate(77.847 4921.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_912",
    "data-name": "Trazado 912",
    d: "M2429.769,206.222a.348.348,0,0,1-.082-.01l-2.245-.546a.349.349,0,1,1,.165-.678l2.246.546a.349.349,0,0,1-.083.688",
    transform: "translate(72.158 4911.489)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_913",
    "data-name": "Trazado 913",
    d: "M2363.919,142.844a.348.348,0,0,1-.328-.232,1.69,1.69,0,0,0-1.856-1.228.349.349,0,0,1-.124-.687,2.379,2.379,0,0,1,2.636,1.68.349.349,0,0,1-.329.466",
    transform: "translate(129.438 4967.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_914",
    "data-name": "Trazado 914",
    d: "M2324.583,142.764a.349.349,0,0,1-.226-.615c.335-.284,1.224-1.038,1.627-.583a.349.349,0,0,1-.031.492.344.344,0,0,1-.332.072,2.749,2.749,0,0,0-.813.551.349.349,0,0,1-.225.083",
    transform: "translate(161.704 4966.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_915",
    "data-name": "Trazado 915",
    d: "M2333.208,176.649a.35.35,0,0,1-.278-.137c-1.224-1.606,1.129-4.145,1.231-4.252a.349.349,0,1,1,.508.478c-.573.612-1.9,2.407-1.183,3.351a.349.349,0,0,1-.066.489.345.345,0,0,1-.211.072",
    transform: "translate(154.445 4940.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_916",
    "data-name": "Trazado 916",
    d: "M2330.352,164.327a.369.369,0,0,1-.051,0,.349.349,0,0,1-.3-.395l.254-1.775a.349.349,0,1,1,.691.1l-.254,1.775a.348.348,0,0,1-.344.3",
    transform: "translate(156.686 4949.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_917",
    "data-name": "Trazado 917",
    d: "M2370.293,164.283a.353.353,0,0,1-.348-.371l.113-1.79a.34.34,0,0,1,.37-.326.349.349,0,0,1,.327.37l-.113,1.79a.35.35,0,0,1-.349.327",
    transform: "translate(121.941 4949.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_918",
    "data-name": "Trazado 918",
    d: "M2323.414,92.957a3.185,3.185,0,0,1,2.68-1.565,4.067,4.067,0,0,1,3,1.272s-.782,3.179,1.8,4.827a6.254,6.254,0,0,0,4.555,1.151l1.846-.686,1.324-2.73-5.445-5.713-7-3.574-3.5,3.262Z",
    transform: "translate(163.059 5015.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_919",
    "data-name": "Trazado 919",
    d: "M2349.884,215.364c-.083,0-.137,0-.149,0a.348.348,0,0,1-.318-.375.344.344,0,0,1,.374-.321,2.2,2.2,0,0,0,2.119-1.229.349.349,0,1,1,.635.288,2.854,2.854,0,0,1-2.661,1.642",
    transform: "translate(139.798 4904.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_921",
    "data-name": "Trazado 921",
    d: "M2337.59,297.239a17.242,17.242,0,0,1-4.351-.555.349.349,0,0,1,.192-.671,16.953,16.953,0,0,0,5.245.488,14,14,0,0,0,6.282-2.535.349.349,0,1,1,.419.557,14.451,14.451,0,0,1-6.65,2.674c-.388.029-.77.042-1.138.042",
    transform: "translate(154.089 4834.142)",
    fill: "#ffbf69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1021",
    "data-name": "Trazado 1021",
    d: "M2.136,0A3.056,3.056,0,0,0,.124,1.553a1.817,1.817,0,0,0-.11.867,2.122,2.122,0,0,0,.462.985c1.4,1.677,7.17,1.538,7.17,1.538,3.869-.093,5.921-.363,9.133-.5,1.8-.08,3.34-.091,4.486-.083a.088.088,0,0,0,.018-.174L2.136,0",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1636.594, 257.451)",
    fill: "#c6783a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1022",
    "data-name": "Trazado 1022",
    d: "M0,0,1.64,5.059A4.138,4.138,0,0,1,3.964,6.92a3.42,3.42,0,0,1,.263.645l.425-.185a.934.934,0,0,0,.5-1.2L3.242,1.3Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1654.102, 263.606)",
    fill: "#fae8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1023",
    "data-name": "Trazado 1023",
    d: "M20,12.008a.991.991,0,0,1-1.042,1.02c-2.172-.111-4-.253-5.391-.376-3.544-.314-2.1-.318-6.253-.749-2.773-.287-4.2-.367-5.67-1.441A6.744,6.744,0,0,1,0,8.711,10.584,10.584,0,0,1,4.369,1.7,10.276,10.276,0,0,1,11.031.048a10.005,10.005,0,0,1,4.025,1.51C19.291,4.345,19.932,9.693,20,12.008",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1640.495, 249.376)",
    fill: "#f2b05b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1024",
    "data-name": "Trazado 1024",
    d: "M11.341,2.9a9.073,9.073,0,0,0-7.687-.57A8.349,8.349,0,0,0,0,5.436,6.623,6.623,0,0,1,2.978.894,6.461,6.461,0,0,1,9.465.852,3.653,3.653,0,0,1,11.341,2.9",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1646.729, 252.519)",
    fill: "#c6783a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoyride);
export default __webpack_public_path__ + "static/media/joyride.843ca668a9c8c9eecdd4c5ab60e7958e.svg";
export { ForwardRef as ReactComponent };